'use strict';
import React, { PureComponent } from 'react';
import CabeceraGrilla from './CabeceraGrilla.jsx'
import RegistroGrilla from './RegistroGrilla.jsx'


class SeccionGrilla extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const { 
            datosGrilla,
            ordenGrilla,
            columnaActivaOrdenamiento,
            primeraCargaPantalla
        } = this.props;

        //ACTIONS
        const { 
            cambiarOrden,
            routeToABMModelos
        } = this.props;

        const registrosArray = [];
        /* const arrayMockRegistros = [
            {Id: 1,  Codigo: 119, Descripcion: "AUTORIZACIÓN DE CONSUMOS ME", Marca: "VISA"},
            {Id: 2,  Codigo: 120, Descripcion: "AUTORIZACIÓN ADELANTO USD", Marca: "VISA"},
            {Id: 3,  Codigo: 121, Descripcion: "PRESENTACION CONSUMOS ME", Marca: "CABAL"},
            {Id: 4,  Codigo: 122, Descripcion: "PRESENTACION ADELANTO EFECTIVO USD", Marca: "VISA"},
            {Id: 5,  Codigo: 123, Descripcion: "PRESENTACIÓN IPM CONSUMOS ME", Marca: "VISA"},
            {Id: 6,  Codigo: 124, Descripcion: "AUTORIZACIÓN DEVOLUCION ARS", Marca: "VISA"},
            {Id: 7,  Codigo: 125, Descripcion: "PRESENTACION DEVOLUCION ARS", Marca: "CABAL"},
            {Id: 8,  Codigo: 126, Descripcion: "AUTORIZACION DEVOLUCION ME", Marca: "VISA"},
            {Id: 9,  Codigo: 127, Descripcion: "PRESENTACION DEVOLUCION ME", Marca: "VISA"},
            {Id: 10, Codigo: 128, Descripcion: "DEVOLUCION IPM ME", Marca: "VISA"},
        ]; */

        datosGrilla?.map((reg, index) => {
            let esPar = (index + 1) % 2 == 0;

            registrosArray.push(<RegistroGrilla key={reg.Codigo} data={reg} esPar={esPar} routeToABMModelos={routeToABMModelos} />);
        });

        const sinResultados = datosGrilla?.length == 0;

        return (
            <div className="seccionGrilla">
                <CabeceraGrilla 
                    ordenGrilla={ordenGrilla}
                    cambiarOrden={cambiarOrden}
                    columnaActivaOrdenamiento={columnaActivaOrdenamiento}
                />

                <div>
                    {sinResultados && !primeraCargaPantalla ?
                        <div className="seccionGrilla__registro--SinResultados">No se encontraron resultados</div>
                    :
                        registrosArray
                    }
                </div>
            </div>
        );
    }
}

export default SeccionGrilla;